module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAALVBMVEVHcEz////////////////////////////////////////////////////////NXt0CAAAADnRSTlMA6vqxlgU303gciBNZnHu84fMAAADISURBVHja3ZVJDsMwCEXLEI8J9z9u1A2ykhhovctbWv9JIGH4vJNUKAMiZCrJT9cGMgCtmvF+oFxA7vP8DvIA7JP4dsgE3h7zJFNoc/O+cYgJ3/oVh0vnHTwBulnQ980qqqIvYB2EJr4gbRAgICAM8ykhkgolJhQVKCaQCjkm5KFnq2kFVMCYgD8L/5eUY0JWgWICqVBiQlEhxYQUGz4FFsY7/oEU9gVeWwLxNaOwmPD6qvSX8d1gY90vHhSls32y4kcxfnZfyQkE3D/FBJg0hAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/info.png
// module id = 42
// module chunks = 0